import {ApiHostsEnum} from '../../index';
import createApiHostSelector from '../createApiHostSelector';


const selectGardenHost = createApiHostSelector(ApiHostsEnum.garden);

export default selectGardenHost;
